// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SgwpH","top":"styles_top__1vR9t","left":"styles_left__zt_s8","description":"styles_description__25W6X"};